<template>
  <div>
    <v-row>
        <v-col cols="12" md="12">
            <v-autocomplete
                    dense
                    outlined
                    placeholder="All Operators"
                    label="Operator"
                    v-model="operator.selected"
                    @change="execFilter('operator')"
                    :items="operator.items"
                    item-text="name"
                    item-value="OperatorID"
                    :rules="operator.rule"
                    :loading="operator.loader"
                    :disabled="operator.disable"
                    hide-details
                    >
                    </v-autocomplete>
        </v-col>
        <v-col cols="12" md="12">
            <v-autocomplete
            dense
            outlined
            placeholder="All Car Parks"
            label="Car Park"
            v-model="carpark.selected"
            @change="execFilter('carpark')"
            :items="carpark.items"
            item-text="name"
            item-value="CarParkID"
            :rules="carpark.rule"
            :loading="carpark.loader"
            :disabled="carpark.disable"
            hide-details
            >
            </v-autocomplete>
        </v-col>
    </v-row>
    <v-card class="mx-auto" outlined>
            <v-card-title>Dashboard</v-card-title>
            <v-container fluid>
              <line-chart
                  v-if="loaded"
                  :chartdata="chartdata"
                  :options="options"/>
            </v-container>
    </v-card>
  </div>
</template>

<script>
import LineChart from './chart/Chart.vue'
import axios from 'axios';
import * as moment from "moment";
export default {
    name: 'dashboard',
    title: 'dashboard',

    components: { LineChart },

    data: () => ({
    loaded: false,
    chartdata: {
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [
        {
          label: 'Arrival',
          backgroundColor: '#C8B8DB ',
          data: [10, 0, 100, 50, 850, 10]
        },

        {
          label: 'Occupancy',
          backgroundColor: '#CDE7B0',
          data: [32, 0, 100, 500, 800, 70]
        },

        {
          label: 'Departures',
          backgroundColor: '#A3BFA8',
          data: [40, 0, 100, 100, 500, 100]
        }
      ]
    },

    options: {
      responsive: true,
      maintainAspectRatio: false
    },
    operator: {
        items: [],
        itemsFull: [],
        selected: '',
        loader: false,
        disable: false,
        rule: []
    },
    carpark: {
        items: [],
        itemsFull: [],
        selected: '',
        loader: false,
        disable: false,
        rule: []
    },
  }),
  async mounted () {
    this.loaded = false
    try {
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      const result = await axios.get(`${process.env.VUE_APP_ANALYSIS_ENDPOINT}/report/occupancy/carpark/5?startDate=1756656000&endDate=1756742400`);
      // console.log(result.data)
      // this.chartdata.labels = [];
      // this.chartdata.datasets[0].data= [];
      // this.chartdata.datasets[1].data= [];
      // this.chartdata.datasets[2].data= [];
      // result.data.records.forEach((item)=>{
      //   this.chartdata.labels.push(moment(item.bucket_ts).local().format('HH:mm:ss'))
      //   this.chartdata.datasets[0].data.push(item.arrivals);
      //   this.chartdata.datasets[1].data.push(item.occupancy);
      //   this.chartdata.datasets[2].data.push(item.departures);
      // });
      // //this.chartdata = userlist
      // this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },

  async created(){
    await this.getOperatorFull();
    await this.getCarParkFull();
    window.addEventListener("unload", (evt) => this.onUnload({operator: this.operator.selected, carpark: this.carpark.selected}, evt));
    this.operator.selected = JSON.parse(AppStorage.get('filter')).operator;
    this.carpark.selected = JSON.parse(AppStorage.get('filter')).carpark;
  },

  methods: {
    async getOperatorFull(){
      let list = [];
      this.operator.items = [];
      this.operator.selected = "";

      try{
          this.operator.loader = true;
          this.operator.disable = true;

          let self = this;
          let response = await this.$store.dispatch("listOperator", {search: ''});
          let dt = response.data.record;
          if (response.data.code == 'AP000'){

          for(var i=0; i<dt.length; i++){
              if (dt[i].SystemID === 2){
                  dt[i].name = `${dt[i].OperatorID} - ${dt[i].OperatorName}`;
                  this.operator.items.push({name: dt[i].name, OperatorID: dt[i].OperatorID});
                  this.operator.itemsFull.push(dt[i]);
              }
          }

          this.operator.selected = this.operator.items[0].OperatorID;
          }

          //this.operator.itemsFull = dt;

          this.operator.loader = false;
          this.operator.disable = false;
      }

      catch(err){
          console.log(err);
      }

      return list;
    },
    async getCarParkFull(){
        let list = [];
        this.carpark.items = [];
        this.carpark.selected = "";

        try{
            this.carpark.loader = true;
            this.carpark.disable = true;

            let self = this;

            if (this.operator.selected){
                let carpark = this.carpark.itemsFull.filter(item => {
                return item.OperatorID == self.operator.selected;
                });


                for(var i=0; i<carpark.length; i++){
                    carpark[i].name = `${carpark[i].CarParkID} - ${carpark[i].CarParkName}`;
                    this.carpark.items.push({name: carpark[i].name, CarParkID: carpark[i].CarParkID});
                }

                //this.operator.selected = this.operator.items[1].OperatorID;
            }

            else{
                let response = await this.$store.dispatch("getAllCarpark2", {});
                let dt = response.data.record;
                if (response.data.code == 'AP000'){

                for(var i=0; i<dt.length; i++){
                    if (dt[i].SystemID === 2){
                        dt[i].name = `${dt[i].CarParkID} - ${dt[i].CarParkName}`;
                        this.carpark.items.push({name: dt[i].name, CarParkID: dt[i].CarParkID});
                        this.carpark.itemsFull.push(dt[i]);
                    }
                }

                this.carpark.selected = this.carpark.items[0].CarParkID;
                }
            }

            //this.operator.itemsFull = dt;

            this.carpark.loader = false;
            this.carpark.disable = false;
        }

        catch(err){
            console.log(err);
        }

        return list;
    },
    async execFilter(type){
        if (type == 'system'){
            await this.getOperatorFull();
            await this.getCarParkFull();
        }

        if (type == 'operator'){
            await this.getCarParkFull();
        }

        if (type == 'carpark'){
        }
    },
  }
    
}
</script>

<style lang="scss" scoped>
    .dashboard-card{
        flex: 1 0 21%; /* explanation below */
    }

    .doc-card-title{
        margin-left: -24px;
        padding: 2px 10px 2px 24px;
        background: #e0e0e0;
        color: #616161;
        position: relative;
        border-radius: 3px 5px 5px 0;
    }

    .slide-fade-enter-active {
  transition: all .9s ease;
}
.slide-fade-leave-active {
  transition: all .12s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(-50px);
  opacity: 0;
}

.slide-fade-leave-to{
	transform: translateX(50px);
  	opacity: 0;
}

.grow { transition: all .2s ease-in-out; }
.grow:hover { transform: scale(1.05); }

.user-select-none{
    user-select: none;
}
</style>